"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authRequestMiddleware = authRequestMiddleware;
exports.authRouteMiddleware = authRouteMiddleware;
function authRequestMiddleware(auth) {
  return function (url, options = {}) {
    if (!auth || !auth.state || !auth.state.access_token) {
      return;
    }
    const companyId = auth.state.claims.company_id;
    options.headers = {
      ...(options.headers || {}),
      'company-id': options?.headers?.['company-id'] ? options.headers['company-id'] : companyId,
      'x-company-id': options?.headers?.['x-company-id'] ? options.headers['x-company-id'] : companyId,
      'authorization': `Bearer ${auth.state.access_token}`
    };
  };
}
function authRouteMiddleware(auth) {
  return function (action, nextRoute, prevRoute) {
    // we aren't signed in yet, so continue
    if (!auth.state.access_token) {
      return action.ok();
    }
    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if (nextCompanyId === auth.state.claims.company_id) {
      return action.ok();
    }
    if (nextCompanyId) {
      // switch to the new company
      auth.delegate(nextCompanyId).then(() => {
        action.ok();
      }).catch(error => {
        console.error(error);
      });
    } else {
      action.ok();
    }
  };
}
//# sourceMappingURL=auth.js.map